/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'reactstrap'

import { BUTTON_VARIANTS, Button, Arrow, KilliIcon } from './styles'

const RoundedButton = forwardRef(
  (
    {
      buttonText = null,
      children = null,
      variant = 'primary',
      iconName = null,
      withArrow = false,
      disabled = false,
      isLoading = false,
      onPress = null,
      className = '',
      ...props
    },
    ref,
  ) => (
    <Button
      ref={ref}
      onClick={isLoading || disabled ? null : onPress}
      className={[!isLoading && withArrow ? 'with-arrow' : '', className].join(' ')}
      disabled={disabled || isLoading}
      variant={variant}
      {...props}
    >
      {isLoading ? (
        <Spinner size="sm" />
      ) : (
        <>
          <span>
            {iconName && <KilliIcon className={`killi-icon-${iconName}`} />}
            {buttonText || children}
          </span>
          {withArrow && <Arrow variant={variant} disabled={disabled} />}
        </>
      )}
    </Button>
  ),
)

RoundedButton.propTypes = {
  buttonText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  onPress: PropTypes.func,
  variant: PropTypes.oneOf(Object.keys(BUTTON_VARIANTS)),
  iconName: PropTypes.string,
  withArrow: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
}

export default RoundedButton
